import React from 'react';
import { useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useMutation } from '../../../../../graphql/hooks';
import { UPDATE_EMPLOYEE, GET_EMPLOYEES, GET_EMPLOYEE, DELETE_EMPLOYEE } from '../../../graphql';
import { OnSubmitType, UpdateEmployeeMutationResult, UpdateEmployeeFormQueryProps, UpdateEmployeeProps } from '../types';
import Query from '../../../../../graphql/Query';
import { routePaths } from '../../../../../routePaths';
import EmployeeForm from '../EmployeeForm';
import { mapIds, getId } from '../../../../../utils';
import { EditFormLayout } from '../../../../../ui-kit';
import { useUser } from '../../../../../utils/hooks/auth';

const UpdateEmployeeForm = ({ employeeId }: UpdateEmployeeProps) => {
    const [update, { loading }] = useMutation<UpdateEmployeeMutationResult>(UPDATE_EMPLOYEE);
    const { isAdmin } = useUser();

    const [remove] = useMutation<boolean>(
        DELETE_EMPLOYEE,
        { refetchQueries: [{ query: GET_EMPLOYEES }] }
    );

    const history = useHistory();

    const onSubmit: OnSubmitType = async values => {
        const { venueIds, defaultVenueId, ...rest } = values;
        const mappedVenueIds: string[] = mapIds(venueIds);
        const variables = { ...rest, id: employeeId, venueIds: mappedVenueIds, defaultVenueId };
        await update({ variables });
        history.push(routePaths.employee);
    };

    const onClick = async () => {
        try {
            await remove({ variables: { id: employeeId } });
        } catch (error) {
            // nothing we can do
        }

        history.push(routePaths.employee);
    };
    const { t } = useTranslation();

    return (
        <Query<UpdateEmployeeFormQueryProps> query={GET_EMPLOYEE} variables={{ id: employeeId }}>
            {({ data: { employee, venues } }) => {
                const { account : { email, firstName, lastName }, venues: venueIds, currentVenue, pin, role } = employee;
                const defaultVenueId: string = getId(currentVenue);
                const initialValues = {
                    email,
                    firstName,
                    lastName,
                    pin: pin || '',
                    password: '',
                    role,
                    venueIds,
                    defaultVenueId,
                };
                return (
                    <EditFormLayout
                        onRemove={isAdmin ? onClick : undefined}
                        title={t('Update Member')}
                        buttonText={t('Delete Member')}
                    >
                        <EmployeeForm
                            onSubmit={onSubmit}
                            isLoading={loading}
                            initialValues={initialValues}
                            venues={venues || []}
                            submitText={t('Update')}
                            isUpdate
                        />
                    </EditFormLayout>
            );
            }}
        </Query>
    );
};

export default UpdateEmployeeForm;
